module.exports = __webpack_public_path__ + "static/media/profile.be515f6e.svg";